import { render } from "./TreeContracts.vue?vue&type=template&id=d667ad60&scoped=true"
import script from "./TreeContracts.vue?vue&type=script&lang=js"
export * from "./TreeContracts.vue?vue&type=script&lang=js"

import "./TreeContracts.vue?vue&type=style&index=0&id=d667ad60&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d667ad60"]])

export default __exports__